<template>
  <div>
    <span>user</span>
  </div>
</template>

<script>
export default {
  name: "UserPage",
  data() {
    return {
      title: "123",
    };
  },
};
</script>